import React, { useEffect, useState } from "react";
import { Grid, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import {CountryList} from '../../../../components/CountryList'
const DEFAULT_DESIGN = "https://via.placeholder.com/200x200";
const INIT_FORM_DATE = {
	merchantName: "",
	imageUrl: "",
	country: "",
};
const INIT_ERRORS = {
	merchantName: "",
	imageUrl: "",
};
const AddMerchantModal = ({ isVisible, onClose, onCreate, existingFormData }) => {
	const theme = useTheme();

	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState(INIT_FORM_DATE);
	const [backgroundImage, setBackgroundImage] = useState(DEFAULT_DESIGN);
	const [image, setImage] = useState(null);

	useEffect(() => {
		if (existingFormData) {
			setFormData(existingFormData);
			setBackgroundImage(existingFormData.imageUrl);
		}
	}, [existingFormData]);

	const handleCloseModal = () => {
		setBackgroundImage(DEFAULT_DESIGN);
		setErrors(INIT_ERRORS);
		setFormData(INIT_FORM_DATE);
		onClose(false);
	};

	const validateField = (name, value) => {
		switch (name) {
			case "merchantName":
				setErrors((prevState) => ({
					...prevState,
					merchantName: value ? "" : "Merchant name is required.",
				}));
				break;
			default:
				break;
		}
	};

	const handleImageChange = (event) => {
		setErrors((prevState) => ({
			...prevState,
			imageUrl: "",
		}));
		const file = event.target.files[0];
		setImage(event.target.files[0]);
		const reader = new FileReader();
		reader.onload = () => {
			setBackgroundImage(reader.result);
		};
		if (file) {
			reader.readAsDataURL(file);
		}
	};

	const handleInputChange = (event) => {
		const { id, value } = event.target;
		console.log("State",id, "   ", value)
		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));
		validateField(id, value);
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	};

	const inputProps = {
		required: true,
		fullWidth: true,
		margin: "normal",
		onChange: handleInputChange,
	};

	const onCreateHandler = () => {
		const items = Object.keys(formData);
		items.forEach((item) => {
			validateField(item, formData[item]);
		});

		if (!isUpdate && !image) {
			setErrors((prevState) => ({
				...prevState,
				image: "Image is required",
			}));
		}

		const allFieldsOk = Object.values(errors).every((x) => x === null || x === "");
		console.log({ allFieldsOk, errors });
		
		if (allFieldsOk) {
			onCreate({ ...formData, image, isUpdate });
			handleCloseModal();
		}
	};
	
	return (
		<Dialog open={isVisible} onClose={onClose} fullScreen={fullScreen} scroll="paper">
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Gift Merchant
			</DialogTitle>
			<DialogContent dividers>
				<Grid container rowSpacing={50}>
					<Grid item md={6} xs={12}>
						<img src={backgroundImage} width={"90%"} height={"90%"} alt="Gift design" loading="lazy" />
						<input type="file" name="image" accept="image/*" width={"90%"} height={"90%"} onChange={handleImageChange} />
						{errors.image && <span style={{ color: "#d32f2f" }}>{errors.image}</span>}
					</Grid>
					<Grid item md={6} xs={12}>
						<TextField {...inputProps} id="merchantName" label="Merchant name" value={formData.merchantName} error={!!errors.merchantName} helperText={errors.merchantName} />
						<CountryList {...inputProps}
						onChange={handlSelectChange}
							 placeholder="Select Country" id="country" label="Country name" 
							 value={formData.country!=null?formData.country:""} error={!!errors.merchantName} helperText={errors.merchantName} >
							
						</CountryList>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button variant="contained" onClick={onCreateHandler} disabled={!formData.merchantName || (!isUpdate && !image)}>
					{isUpdate ? "Update" : "Create"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddMerchantModal;
